import type React from 'react';
import { Layout } from './Layout';

interface ProtectedRouteViewProps {
  onSignIn: () => void;
  onBack: () => void;
}

export const ProtectedRouteView: React.FC<ProtectedRouteViewProps> = ({ onSignIn, onBack }) => (
  <Layout>
    <h1 id="sign-in-required-title" className="sign-in-required__title">
      Authentication required
    </h1>
    <p className="sign-in-required__description">
      You need to sign in to access this page. Please sign in to continue.
    </p>
    <div className="sign-in-required__actions">
      <button
        type="button"
        onClick={onSignIn}
        className="sign-in-required__button sign-in-required__button--primary"
      >
        Sign In
      </button>
      <button
        type="button"
        onClick={onBack}
        className="sign-in-required__button sign-in-required__button--text"
      >
        Back to Home
      </button>
    </div>
  </Layout>
);
